var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.layout.hideNav)?_c('nav-bar',{staticClass:"do-not-print"}):_vm._e(),_vm._v(" "),_c('router-view',{on:{"modifyLayout":_vm.modifyLayout}}),_vm._v(" "),(!_vm.layout.hideFooter)?_c('site-footer',{staticClass:"do-not-print",attrs:{"minimal":_vm.layout.minimalFooter}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1518e69f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = qnTj
// module chunks = 26